<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo -->
    <div class="navbar-brand">
      <a (click)="goToHome()" style="cursor: pointer;">
            <img ngSrc="assets/loghi/agriflow_logo_orizzontale_TRASPARENTE_optimized.png"
                 alt="AgriFlow"
                 class="logo-image"
                 width="180"
                 height="120"
                 priority />

      </a>
     <!--  <span class="logo-text">AgriFlow</span> -->
    </div>

        <!-- Menu principale -->
        <div class="navbar-menu" [class.mobile-hidden]="!showMobileMenu">
          <!-- Menu per utenti autenticati -->
          <a routerLink="/home"
             routerLinkActive="active"
             class="nav-link"
             *ngIf="isAuthenticated">
            <i class="pi pi-home"></i>
            <span>{{ 'HOME' | translate }}</span>
          </a>
          <!-- Menu Fascicoli - nascosto per beneficiari -->
          <div class="nav-dropdown" *ngIf="isAuthenticated && !isBeneficiario()">
            <a class="nav-link dropdown-trigger"
               [class.active]="isFascicoliMenuActive()"
               (click)="toggleFascicoliMenu($event)">
              <app-material-icon iconName="home_storage" [outlined]="true" [size]="20"></app-material-icon>
              <span>FASCICOLI</span>
              <i class="pi pi-chevron-down dropdown-arrow"></i>
            </a>
            <div class="dropdown-menu" [class.show]="showFascicoliMenu">
              <a routerLink="/fascicoli"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/fascicoli') && !currentRoute.includes('/domande')"
                 (click)="closeFascicoliMenu()">
                 <app-material-icon iconName="library_books" [outlined]="true" [size]="18"></app-material-icon>

                <span>Tutti i fascicoli</span>
              </a>
              <a routerLink="/fascicoli/domande-sostegno"
                 class="dropdown-item"
                 [class.active]="currentRoute.includes('/domande-sostegno')"
                 (click)="closeFascicoliMenu()">
                <app-material-icon iconName="description" [outlined]="true" [size]="18"></app-material-icon>
                <span>Domande di sostegno</span>
              </a>
              <a routerLink="/fascicoli/domande-pagamento"
                 class="dropdown-item"
                 [class.active]="currentRoute.includes('/domande-pagamento')"
                 (click)="closeFascicoliMenu()">
                <app-material-icon iconName="payment" [outlined]="true" [size]="18"></app-material-icon>
                <span>Domande di pagamento</span>
              </a>
              <a routerLink="/beneficiari"
                routerLinkActive="active"
                [class.active]="currentRoute.startsWith('/beneficiari')"
                (click)="closeFascicoliMenu()"
                class="dropdown-item"
                >
                <app-material-icon iconName="article_person" [outlined]="true" [size]="18"></app-material-icon>
                <span>Beneficiari</span>
              </a>
            </div>
          </div>
          <!-- Menu Controlli - nascosto per beneficiari -->
          <div class="nav-dropdown" *ngIf="isAuthenticated && !isBeneficiario()">
            <a class="nav-link dropdown-trigger"
               [class.active]="isControlliMenuActive()"
               (click)="toggleControlliMenu($event)">
              <app-material-icon iconName="plagiarism" [outlined]="true" [size]="20"></app-material-icon>
              <span>CONTROLLI</span>
              <i class="pi pi-chevron-down dropdown-arrow"></i>
            </a>
            <div class="dropdown-menu" [class.show]="showControlliMenu">
             <!--  <a routerLink="/ispezioni"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/ispezioni')"
                 (click)="closeControlliMenu()">
                 <app-material-icon iconName="document_search" [outlined]="true" [size]="18"></app-material-icon>

                <span>Ispezioni</span>
              </a> -->
              <a routerLink="/controlli-ta"
                  class="dropdown-item"
                  [class.active]="currentRoute.startsWith('/controlli-ta')"
                  (click)="closeControlliMenu()">
                  <app-material-icon iconName="fact_check" [outlined]="true" [size]="18"></app-material-icon>

                <span>Tecnico Amministrativi</span>
              </a>
              <a routerLink="/controlli-in-situ"
                  class="dropdown-item"
                  [class.active]="currentRoute.startsWith('/controlli-in-situ')"
                  (click)="closeControlliMenu()">
                  <app-material-icon iconName="share_location" [outlined]="true" [size]="18"></app-material-icon>

                <span>In Situ</span>
              </a>
              <a routerLink="/controlli-in-loco"
                  class="dropdown-item"
                  [class.active]="currentRoute.startsWith('/controlli-in-loco')"
                  (click)="closeControlliMenu()">
                  <app-material-icon iconName="search_check_2" [outlined]="true" [size]="18"></app-material-icon>

                <span>In Loco</span>
              </a>
              <a
                routerLink="/controllori"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/controllori')"
                 (click)="closeControlliMenu()"
                 *ngIf="!isIstruttoreOrControllore()">
                <app-material-icon iconName="person_search" [outlined]="true" [size]="18"></app-material-icon>
                <span>Controllori</span>
              </a>
              <a
                routerLink="/istruttori"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/istruttori')"
                 (click)="closeControlliMenu()"
                 *ngIf="!isIstruttoreOrControllore()">
                <app-material-icon iconName="integration_instructions" [outlined]="true" [size]="18"></app-material-icon>
                <span>Istruttori</span>
              </a>
              <a routerLink="/distanza-apiari"
                class="dropdown-item"
                [class.active]="currentRoute.startsWith('/distanza-apiari')"
                (click)="closeControlliMenu()">
                <app-material-icon iconName="hive" [outlined]="true" [size]="18"></app-material-icon>
                <span>Distanza Apiari</span>
              </a>

            </div>
          </div>
         <!--  <a routerLink="/monitoring"
             routerLinkActive="active"
             class="nav-link"
             *ngIf="isAuthenticated">
            <i class="pi pi-chart-line"></i>
            <span>{{ 'monitoring' | translate }}</span>
          </a> -->


          <!-- Menu Configurazione - nascosto per beneficiari -->
          <div class="nav-dropdown" *ngIf="isAuthenticated && !isBeneficiario()">
            <a class="nav-link dropdown-trigger"
               [class.active]="isConfigMenuActive()"
               (click)="toggleConfigMenu($event)">
              <app-material-icon iconName="construction" [outlined]="true" [size]="20"></app-material-icon>
              <span>CONFIGURAZIONE</span>
              <i class="pi pi-chevron-down dropdown-arrow"></i>
            </a>
            <div class="dropdown-menu" [class.show]="showConfigMenu">
              <a routerLink="/bandi"
                  class="dropdown-item"
                  [class.active]="currentRoute.startsWith('/bandi')"
                  (click)="closeConfigMenu()">
                <app-material-icon iconName="summarize" [outlined]="true" [size]="20"></app-material-icon>
                <span>BANDI</span>
              </a>
             <a routerLink="/documenti"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/documenti')"
                 (click)="closeConfigMenu()">
                 <app-material-icon iconName="description" [outlined]="true" [size]="20"></app-material-icon>

                <span>DOCUMENTI</span>
              </a>
              <a routerLink="/utenti"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/utenti')"
                 (click)="closeConfigMenu()"
                 *ngIf="!isIstruttoreOrControllore()">
                <i class="pi pi-users"></i>
                <span>UTENTI</span>
              </a>

              <a routerLink="/veci/ico"
                class="dropdown-item"
                [class.active]="currentRoute.startsWith('/veci/ico')"
                (click)="closeConfigMenu()">
                <app-material-icon iconName="checklist" [outlined]="true" [size]="20"></app-material-icon>

              <span>VECI</span>
           </a>
             <!--  <a routerLink="/ruoli"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/ruoli')"
                 (click)="closeConfigMenu()">
                <i class="pi pi-key"></i>
                <span>RUOLI</span>
              </a>
              <a routerLink="/permessi"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/permessi')"
                 (click)="closeConfigMenu()">
                <i class="pi pi-shield"></i>
                <span>PERMESSI</span>
              </a>
              <a routerLink="/impostazioni"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/impostazioni')"
                 (click)="closeConfigMenu()">
                <i class="pi pi-cog"></i>
                <span>IMPOSTAZIONI</span>
              </a> -->
            </div>
          </div>
          <!-- Menu Supporto - nascosto per beneficiari -->
          <div class="nav-dropdown" *ngIf="isAuthenticated && !isBeneficiario()">
            <a class="nav-link dropdown-trigger"
               [class.active]="isSupportMenuActive()"
               (click)="toggleSupportMenu($event)">
              <i class="pi pi-question"></i>
              <span>SUPPORTO</span>
              <i class="pi pi-chevron-down dropdown-arrow"></i>
            </a>
            <div class="dropdown-menu" [class.show]="showSupportMenu">
              <a routerLink="/supporto/faq"
                 class="dropdown-item"
                 [class.active]="currentRoute.startsWith('/supporto/faq')"
                 (click)="closeSupportMenu()">
                <i class="pi pi-question-circle"></i>
                <span>FAQ</span>
              </a>
              <a class="dropdown-item"
                 style="cursor: pointer"
                 (click)="openManualeWip(); closeSupportMenu()">
                <i class="pi pi-book"></i>
                <span>Manuale</span>
              </a>
              <!--
              routerLink="/supporto/segnalazioni"  [class.active]="currentRoute.startsWith('/supporto/segnalazioni')"
            -->
              <a
                 class="dropdown-item"
                 style="cursor: pointer"
                 (click)="openSupportTicket(); closeSupportMenu()">
                <i class="pi pi-ticket"></i>
                <span>Segnalazioni</span>
              </a>
            </div>
          </div>

          <!-- Menu per utenti non autenticati -->
         <!--  <a routerLink="/"
             routerLinkActive="active"
             class="nav-link"
             *ngIf="!isAuthenticated">
            <i class="pi pi-home"></i>
            <span>{{ 'home' | translate }}</span>
          </a>
          <a (click)="scrollToSection('.features-section')"
             class="nav-link"
             *ngIf="!isAuthenticated">
            <i class="pi pi-star"></i>
            <span>{{ 'features' | translate }}</span>
          </a>
          <a (click)="scrollToSection('.cta-section')"
             class="nav-link"
             *ngIf="!isAuthenticated">
            <i class="pi pi-info-circle"></i>
            <span>{{ 'about' | translate }}</span>
          </a> -->
        </div>

    <!-- Menu utente -->
    <div class="navbar-user">
      <!-- Version Badge per utenti autenticati -->
      <div class="version-badge-navbar"
           [class.version-badge-istruttore-controllore]="isIstruttoreOrControlloreUser"
           *ngIf="isAuthenticated"
           [title]="'Versione: ' + appVersion + ' | Ambiente: ' + environmentName + '\n\nClicca per vedere il changelog'"
           (click)="openChangelog()">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="version-text-navbar">v{{ appVersion }}</span>
      </div>

      <!-- 🎫 Supporto Ticket -->
    <!--   <button
        pButton
        type="button"
        icon="pi pi-ticket"
        class="p-button-text p-button-rounded support-ticket-btn"
        [pTooltip]="'Apri ticket di supporto'"
        tooltipPosition="bottom"
        (click)="openSupportTicket()"
        *ngIf="isAuthenticated">
      </button> -->

      <!-- 🔔 Notifiche PEC -->
      <app-pec-notification-bell *ngIf="isAuthenticated"></app-pec-notification-bell>

      <!-- Menu utente autenticato -->
      <div class="user-menu" *ngIf="isAuthenticated && currentUser">
        <div
          class="user-chip"
          [ngClass]="getRoleChipClass()"
          (click)="onUserMenuToggle($event)">
          <span class="user-initials">{{ getInitials(currentUser.name) }}</span>
          <span class="user-role">{{ getRoleDisplayName() }}</span>
        </div>
        <p-menu #userMenu [model]="userMenuItems" [popup]="true" [appendTo]="'body'"></p-menu>
      </div>


      <!-- Pulsanti per utenti non autenticati -->
      <div class="auth-buttons" *ngIf="!isAuthenticated">
        <button
          pButton
          type="button"
          [label]="'login' | translate"
          class="p-button-outlined"
          (click)="login()">
        </button>
      </div>

      <!-- Menu mobile toggle -->
      <button
        pButton
        type="button"
        icon="pi pi-bars"
        class="p-button-text p-button-rounded mobile-menu-btn"
        (click)="toggleMobileMenu()">
      </button>
    </div>
  </div>


</nav>

<app-wip-dialog
  [(visible)]="showManualeWipDialog"
  title="Manuale utente"
  message="Manuale in corso di elaborazione"
  subtitle="Stiamo preparando una guida completa e aggiornata. Nel frattempo consulta le FAQ o apri una segnalazione."
  iconClass="pi pi-book"
  (onClose)="onManualeWipClose()">
</app-wip-dialog>
